import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Loading from '../containers/Loading.js'
import ShopLink from '../containers/ShopLink.js'

class Interface extends Component {
  render () {
    const {
      className,
      isLoading
    } = this.props

    return (
      <div className={className + (isLoading ? ' isloading' : '')}>
        <Loading />
        <ShopLink className="shoplink"
          content={
            <span className='customhtml'>shop</span>
          }
        />
      </div>
    )
  }
}

Interface.defaultProps = {
  className: 'interface',
  isLoading: true
}

Interface.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool
}

export default Interface
